// Device context is intentionally opt-in and request-scoped. This module
// recognizes only a small, explicit vocabulary for questions about the
// device's current state. It never returns or retains the message itself.

function normalizedMessage(value) {
  return typeof value === 'string'
    ? value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
    : '';
}

// Keep this deliberately aligned with the Worker-side relevance gate. A
// message outside this vocabulary must never cause a context sync only to be
// ignored by the chat endpoint.
const EXPLICIT_BATTERY_REQUEST = /\b(?:bateria|carregador|carregando|energia)\b/;
const EXPLICIT_NETWORK_REQUEST = /\b(?:sem internet|offline|online|rede|wi-?fi|dados moveis)\b/;
const EXPLICIT_AUDIO_ROUTE_REQUEST = /\b(?:fone(?:s)?(?: de ouvido)?|bluetooth|alto[- ]falante|saida de audio|audio do (?:celular|telefone|dispositivo)|som do (?:celular|telefone|dispositivo))\b/;
const CURRENT_STATE_REQUEST = /\?|\b(?:qual|como|quanto|verifique|verificar|cheque|checar|mostre|mostrar|diga|informe|quero saber|preciso saber)\b/;
const ABSTRACT_DEVICE_METAPHOR = /\b(?:social|metafora|emocional|humana|filosofica)\b/;
const BATTERY_DEVICE_CONTEXT = /\b(?:minha bateria|bateria (?:do|no) (?:meu )?(?:celular|telefone|dispositivo)|nivel da bateria|bateria (?:esta|ta) carregando)\b/;
const NETWORK_DEVICE_CONTEXT = /\b(?:minha (?:rede|internet|conexao)|estou (?:sem internet|offline)|(?:rede|internet|wi-?fi|dados moveis|conexao) (?:do|no) (?:meu )?(?:celular|telefone|dispositivo)|(?:wi-?fi|rede) (?:esta|ta) conectad[oa])\b/;
const AUDIO_ROUTE_DEVICE_CONTEXT = /\b(?:meus? fones?(?: de ouvido)?|saida de audio|(?:audio|som) (?:do|no) (?:meu )?(?:celular|telefone|dispositivo)|(?:bluetooth|fone(?:s)?|alto[- ]falante) (?:esta|ta|estao) conectad[oa]s?)\b/;

/**
 * Returns only the bounded signal categories required by an explicit user
 * question. Generic conversation, location, microphone capture and message
 * content never qualify.
 */
export function requestedAthenaDeviceSignalsForMessage(message) {
  const text = normalizedMessage(message);
  if (!text || ABSTRACT_DEVICE_METAPHOR.test(text) || !CURRENT_STATE_REQUEST.test(text)) return Object.freeze([]);

  const signals = [];
  if (EXPLICIT_BATTERY_REQUEST.test(text) && BATTERY_DEVICE_CONTEXT.test(text)) signals.push('battery');
  if (EXPLICIT_NETWORK_REQUEST.test(text) && NETWORK_DEVICE_CONTEXT.test(text)) signals.push('network');
  if (EXPLICIT_AUDIO_ROUTE_REQUEST.test(text) && AUDIO_ROUTE_DEVICE_CONTEXT.test(text)) signals.push('audio');
  return Object.freeze(signals);
}
